export default __webpack_public_path__ + "static/media/guest_7_1_vivian maternativa.a4987db6.png";